import React, { useState } from 'react';
import { Input } from 'antd';
import {
  deleteCustomKPI,
  updateSelectedConfig,
  setEditable,
} from '@store/overviewDashboard/spiThresholds/actions';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon, DeleteIcon, CreateIcon } from '@components/overview-dashboard/common/Icons';
import { isEditableFlagSelector } from '@store/overviewDashboard/spiThresholds/selectors';
import { OVERVIEW_LABELS } from '@src/utils/kpi';
import OverviewModal from '@components/overview-dashboard/common/modal';
import { onClickofCreateNewInAdminHeader, onClickOfDeleteInHeader } from '../helper';
import { AdminHeaderContainer, AdminKPIDropdown, AdminIcon, AdminCreateIcon } from '../styled';
import KPIValues from './KPIValues';

const AdminIcons = ({
  config,
  selectedKPIConfig,
  isEditable,
  selectedKPIConfigID,
  closeEditPopup,
  setCreateNewError,
}) => {
  const dispatch = useDispatch();
  const [isDropdown, showDropDown] = useState(true);
  const [isDeletePopupOpen, showDelete] = useState(false);
  const isBeingEdited = useSelector(isEditableFlagSelector);
  const isActiveKPI = selectedKPIConfigID === selectedKPIConfig.kpiID;

  const cancelDelete = () => {
    showDelete(false);
  };

  const onDelete = () => {
    onClickOfDeleteInHeader(
      isActiveKPI,
      dispatch,
      deleteCustomKPI,
      selectedKPIConfig,
      closeEditPopup,
      showDelete,
    );
  };

  const onClickofEdit = () => {
    dispatch(setEditable(true));
    showDropDown(false);
  };

  const onClickofDelete = () => {
    showDelete(true);
  };

  const onClickofCreateNew = () => {
    onClickofCreateNewInAdminHeader(config, setCreateNewError, dispatch, showDropDown);
  };

  const showDeletePopup = () => {
    const { ACTIVE_KPI_DELETE_CONFIRMATION, OTHER_KPI_DELETE_CONFIRMATION } = OVERVIEW_LABELS;
    const deleteMsg = isActiveKPI ? ACTIVE_KPI_DELETE_CONFIRMATION : OTHER_KPI_DELETE_CONFIRMATION;

    const modalProps = {
      primaryLabel: 'Delete',
      primaryMethod: onDelete,
      secondaryLabel: 'Cancel',
      secondaryMethod: cancelDelete,
      isModalOpen: isDeletePopupOpen,
      modalTitle: deleteMsg,
    };

    return <OverviewModal {...modalProps} />;
  };

  const getDropdown = () => (
    <AdminHeaderContainer>
      {showDeletePopup()}
      <AdminKPIDropdown>
        <KPIValues
          config={config}
          selectedKPIConfig={selectedKPIConfig}
          selectedKPIConfigID={selectedKPIConfigID}
        />
      </AdminKPIDropdown>
      <>
        <div style={{ display: 'flex', padding: '0px 20px', alignItems: 'flex-end' }}>
          {isEditable ? (
            <AdminIcon onClick={onClickofEdit}>
              <EditIcon />
            </AdminIcon>
          ) : (
            <AdminIcon />
          )}
          {isEditable ? (
            <AdminIcon onClick={onClickofDelete}>
              <DeleteIcon />
            </AdminIcon>
          ) : (
            <AdminIcon />
          )}
        </div>
        <AdminCreateIcon onClick={onClickofCreateNew}>
          <CreateIcon />
        </AdminCreateIcon>
      </>
    </AdminHeaderContainer>
  );

  const onKpiNameChange = (event) => {
    dispatch(
      updateSelectedConfig({
        key: 'kpiName',
        value: event.target.value,
      }),
    );
  };

  const getText = () => (
    <AdminHeaderContainer>
      <Input defaultValue={selectedKPIConfig.kpiName} onChange={onKpiNameChange} />
    </AdminHeaderContainer>
  );

  return isBeingEdited ? getText() : getDropdown();
};

export default AdminIcons;
